import React from 'react';

function SafeIcon({ icon: Icon, className = '', ...props }) {
  if (!Icon) {
    return null;
  }

  return <Icon className={className} {...props} />;
}

export default SafeIcon;